"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaSelector = void 0;
var React = require("react");
var moment = require("moment");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var DatePicker_1 = require("components/DatePicker");
var Icon_1 = require("components/Icon");
var MetaSelector = function (props) {
    var options = [
        {
            identifier: null,
            name: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any')
        }
    ].concat(props.metadata);
    return (React.createElement("div", { className: 'sok-form-field text' },
        React.createElement("div", { className: 'input' },
            React.createElement("label", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/meta')),
            React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Dropdown2, { alignment: 'center', isOpen: props.isOpen, onChange: function (value) {
                        props.toggle(value);
                    } },
                    React.createElement("div", { className: 'dropdown-input' },
                        React.createElement("input", { type: 'text', placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any'), value: props.selectedMeta ? props.selectedMeta.name : '' }),
                        React.createElement(Icon_1.Icon, { className: 'fa-caret-down' })),
                    React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall advanced-search-dropdown' }, options.map(function (item, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            props.setMetaValue(null);
                            props.setSelectedMeta(item);
                            props.toggle();
                        } },
                        React.createElement("div", { className: props.selectedMeta &&
                                props.selectedMeta.identifier === item.identifier
                                ? 'active'
                                : '' },
                            React.createElement("label", null, item.name)))); }))),
                (function () {
                    if (!props.selectedMeta) {
                        return null;
                    }
                    if ((props.selectedMeta.type === 'select' ||
                        props.selectedMeta.type === 'dependant-select') &&
                        props.selectedMeta.options) {
                        var selectedOption = props.metaValue &&
                            (props.metaValue.type === 'select' ||
                                props.metaValue.type === 'dependant-select') &&
                            props.metaValue.value
                            ? props.selectedMeta.options.find(function (m) { return m.value === props.metaValue.value; })
                            : undefined;
                        return (React.createElement(sok_ui_1.Dropdown2, { alignment: 'center', isOpen: props.metaOptionIsOpen, onChange: function (value) {
                                props.toggleMetaOption(value);
                            } },
                            React.createElement("div", { className: 'dropdown-input metavalue' },
                                React.createElement("input", { type: 'text', value: selectedOption && selectedOption.name, placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any') }),
                                React.createElement(Icon_1.Icon, { className: 'fa-caret-down' })),
                            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall advanced-search-dropdown' }, props.selectedMeta.options.map(function (o, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    props.setMetaValue({
                                        type: 'select',
                                        value: o.value ? o.value : null
                                    });
                                    props.toggleMetaOption();
                                } },
                                React.createElement("div", { className: props.metaValue && props.metaValue.value === o.value
                                        ? 'active'
                                        : '' },
                                    React.createElement("label", null, o.name)))); }))));
                    }
                    if (props.selectedMeta.type === 'checkbox') {
                        return (React.createElement("div", { className: 'dropdown-input metavalue' },
                            React.createElement(sok_ui_1.Input, { type: 'checkbox', name: props.selectedMeta.identifier, value: props.metaValue &&
                                    props.metaValue.type === 'checkbox' &&
                                    props.metaValue.value === true
                                    ? true
                                    : false, onChange: function (e) {
                                    if (props.metaValue &&
                                        props.metaValue.type === 'checkbox' &&
                                        props.metaValue.value === false &&
                                        e.target.value === 'on') {
                                        props.setMetaValue({
                                            type: props.metaValue.type,
                                            value: true
                                        });
                                    }
                                    else {
                                        props.setMetaValue({ type: 'checkbox', value: false });
                                    }
                                } })));
                    }
                    if (props.selectedMeta.type === 'day' ||
                        props.selectedMeta.type === 'datetime') {
                        var startDate = props.metaValue &&
                            (props.metaValue.type === 'day' ||
                                props.metaValue.type === 'datetime') &&
                            props.metaValue.value.start
                            ? moment(props.metaValue.value.start, 'X')
                            : undefined;
                        var endDate = props.metaValue &&
                            (props.metaValue.type === 'day' ||
                                props.metaValue.type === 'datetime') &&
                            props.metaValue.value.end
                            ? moment(props.metaValue.value.end, 'X')
                            : undefined;
                        return (React.createElement("div", { className: 'dropdown-input metavalue date row' },
                            React.createElement("div", { className: 'column medium-4' },
                                React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/dateFrom'), selected: startDate, onChange: function (m, e) {
                                        if (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                        props.setMetaValue({
                                            type: props.selectedMeta.type,
                                            value: {
                                                start: m
                                                    ? m
                                                        .set({
                                                        hour: 0,
                                                        minute: 0,
                                                        second: 0,
                                                        millisecond: 0
                                                    })
                                                        .unix()
                                                    : null,
                                                end: props.metaValue &&
                                                    (props.metaValue.type === 'day' ||
                                                        props.metaValue.type === 'datetime')
                                                    ? props.metaValue.value.end
                                                    : null
                                            }
                                        });
                                    }, maxDate: endDate, selectsStart: true, dateFormat: 'L' })),
                            React.createElement("div", { className: 'column medium-1 spacer' }, "-"),
                            React.createElement("div", { className: 'column medium-4' },
                                React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/dateTo'), selected: endDate, onChange: function (m, e) {
                                        if (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                        props.setMetaValue({
                                            type: props.selectedMeta.type,
                                            value: {
                                                start: props.metaValue &&
                                                    (props.metaValue.type === 'day' ||
                                                        props.metaValue.type === 'datetime')
                                                    ? props.metaValue.value.start
                                                    : null,
                                                end: m
                                                    ? m
                                                        .set({
                                                        hour: 23,
                                                        minute: 59,
                                                        second: 59,
                                                        millisecond: 59
                                                    })
                                                        .unix()
                                                    : null
                                            }
                                        });
                                    }, minDate: startDate, selectsEnd: true, dateFormat: 'L' }))));
                    }
                    return (React.createElement("div", { className: 'dropdown-input metavalue' },
                        React.createElement("input", { type: 'text', placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any'), value: props.metaValue
                                ? props.metaValue.value
                                : undefined, onChange: function (e) {
                                return props.setMetaValue({ type: 'text', value: e.target.value });
                            } })));
                })()))));
};
exports.MetaSelector = MetaSelector;
